import React from 'react';
import { t } from '../../../locales/i18n';
import { Link } from 'react-router-dom';
import { appSettingsPath } from '../../../navigation';
import { Button, Divider } from 'semantic-ui-react';
import { HeroHeader, HeroContainer, HeroContent, HeroFooter } from '../../../components/layout/layout-components';
import { Segment } from '../../../components/segment';

import styled from 'styled-components';
import { sizes } from '../../../themes/sizes';

const List = styled.ol`
  text-align: left;
  line-height: 2.5em;
  font-size: ${sizes.fonts.large};
  list-style-type: none;
`;

const Actions = styled.div`
  h5 {
    margin-bottom: ${sizes.margins.normal};
  }
`;

export function NoQueueFound() {
  return (
    <HeroContainer>
      <HeroHeader>
        <h1>{t('selectedQueue.noQueueFound')}</h1>
        <h4>{t('selectedQueue.noQueueFoundDetailsHeader')}</h4>
      </HeroHeader>
      <HeroContent>
        <Segment>
          <List>
            <li>{t('selectedQueue.noQueueFoundDetailsNoConnection')}</li>
          </List>
        </Segment>
      </HeroContent>
      <HeroFooter>
        <Actions>
          <h5>{t('selectedQueue.goToSettings')}</h5>
          <Link to={appSettingsPath()}>
            <Button primary basic>
              {t('settings')}
            </Button>
          </Link>
          <Divider horizontal>{t('selectedQueue.orDivider')}</Divider>
          <h5>{t('selectedQueue.tryAgain')}</h5>
          <Button primary basic onClick={() => window.location.reload()}>
            {t('tryAgain')}
          </Button>
        </Actions>
      </HeroFooter>
    </HeroContainer>
  );
}
